import React, { memo } from 'react';
import { Icon } from '@surveycake/rc';
import { handPointerOutlined } from '@surveycake/rc';
import { Typography } from '@surveycake/rc';
import { useSurveyConfig } from 'app/core/survey-config';
import { useTimerTrigger } from './hooks';
import { useStyles } from './styles';

function Trigger() {
  const { wording } = useSurveyConfig();
  const startTimer = useTimerTrigger(wording);
  const styles = useStyles();

  return (
    <div
      className={styles.trigger}
      aria-label="subject timer trigger"
      onClick={startTimer}
    >
      <div className={styles.timerTrigger}>
        <Icon icon={handPointerOutlined} size={2} />
      </div>
      <Typography variant="h5" color="text.white">
        {wording.module.timer.click_to_answer}
      </Typography>
    </div>
  );
}

export default memo(Trigger);
